import scrollSpy from 'simple-scrollspy';

var careAnchors = document.querySelectorAll('.sidenav a');

if( careAnchors ) {
  careAnchors.forEach( (btn) => {
    btn.addEventListener('click', (e)=> {
      var target = e.target.getAttribute('href');
      var element = document.querySelector(target);
      scrollToTargetAdjusted(element);
    });
  });
}

window.scrollToTargetAdjusted = function (element){
  event.preventDefault();
  console.log(element);

  var headerOffset = document.querySelector('.header__navigation').clientHeight + 20;
  var elementPosition = element.getBoundingClientRect().top + document.documentElement.scrollTop;
  var offsetPosition = elementPosition - headerOffset;
  console.log(offsetPosition);

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth"
  });
  return false;
}

window.onload = function() {
  if( window.location.hash ) {
    var element = document.querySelector(window.location.hash);
    scrollToTargetAdjusted(element);
  }

  const pageHeader = document.querySelector('.page-header');

  const sectionOffset = (pageHeader) ? pageHeader.clientHeight : 0;

  // const sectionOffset = document.querySelector('.page-header').clientHeight;
  const offsetVal = '-'+ sectionOffset;
  const offsetInt = parseInt(offsetVal);

  // console.log(offsetInt);

  const options = {
    sectionClass: '.scrollspy',
    menuActiveTarget: '.active',
    offset: offsetInt
  }

  scrollSpy('.sidenav', options)
}



// WEBPACK FOOTER //
// ./scripts/util/sideNav.js